import { ConnectButton } from "@rainbow-me/rainbowkit";
import { observer } from "mobx-react";
import exchangeInterfaceStore from "../stores/ExchangeInterfaceStore";
import { STATUS } from "../utils/constants";

const ConnectWalletButton = () => {
  const { setStatus } = exchangeInterfaceStore;

  return (
    <ConnectButton.Custom>
      {({
        account,
        chain,
        openAccountModal,
        openChainModal,
        openConnectModal,
        authenticationStatus,
        mounted,
      }) => {
        // Note: If your app doesn't use authentication, you
        // can remove all 'authenticationStatus' checks
        const ready = mounted && authenticationStatus !== "loading";
        const connected =
          ready &&
          account &&
          chain &&
          (!authenticationStatus || authenticationStatus === "authenticated");

        return (
          <div
            {...(!ready && {
              "aria-hidden": true,
              style: {
                opacity: 0,
                pointerEvents: "none",
                userSelect: "none",
              },
            })}
          >
            {(() => {
              if (!connected) {
                setStatus(STATUS.WALLET_DISCONNECTED, true);
                return (
                  <button
                    onClick={openConnectModal}
                    type="button"
                    style={{
                      backgroundImage: "url(/assets/images/pepebutton.jpg)",
                    }}
                    className="text-black font-bold rounded-lg p-2 bg-cover hover:bg-center transition-all"
                  >
                    Connect Wallet
                  </button>
                );
              }

              if (chain.unsupported) {
                setStatus(STATUS.WRONG_NETWORK, true);
                return (
                  <button className="text-black font-bold rounded-lg bg-red-400 p-2" onClick={openChainModal} type="button">
                    Wrong network
                  </button>
                );
              }

              setStatus(STATUS.WRONG_NETWORK, false);
              setStatus(STATUS.WALLET_DISCONNECTED, false);

              return (
                <div style={{ display: "flex", gap: 12 }}>
                  <button
                    onClick={openAccountModal}
                    type="button"
                    className=" bg-white text-black rounded-lg p-2 font-bold"
                  >
                    {account.displayName}
                  </button>

                  <button
                    onClick={openChainModal}
                    style={{ display: "flex", alignItems: "center" }}
                    type="button"
                  >
                    {chain.hasIcon && (
                      <div
                        style={{
                          background: chain.iconBackground,
                          width: 32,
                          height: 32,
                          borderRadius: 999,
                          overflow: "hidden",
                          marginRight: 4,
                        }}
                      >
                        {chain.iconUrl && (
                          <img
                            alt={chain.name ?? "Chain icon"}
                            src={chain.iconUrl}
                            style={{ width: 32, height: 32 }}
                          />
                        )}
                      </div>
                    )}
                  </button>
                </div>
              );
            })()}
          </div>
        );
      }}
    </ConnectButton.Custom>
  );
};

export default observer(ConnectWalletButton);
